import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CenteredDialogComponent } from '../components/centered-dialog/centered-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class DialogService {

    constructor(private dialog: MatDialog) { }

    openAutoCloseDialog(message: string): void {
        const dialogRef = this.dialog.open(CenteredDialogComponent, {
            data: message,
            panelClass: 'custom-dialog'
        });

        setTimeout(() => {
            dialogRef.close();
        }, 5000);
    }
}
